<template>
    <div>
        <SubHeader :text="$t('h.wp')" :imgUrl="img" />
        <div class="data">
            <div class="data-cont">
                <h3 class="data-title reveal-bottom">
                    {{ $t("sp.download") }}
                </h3>
                <div class="data-wrap">
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/MAC电脑允许允许第三方软件安装操作.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">
                            MAC电脑允许第三方软件安装操作.pdf
                        </h4>
                        <p class="item-time">2021/5/21</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/Google OTP 服务及企业微信报警说明.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">
                            Google OTP 服务及企业微信报警说明.pdf
                        </h4>
                        <p class="item-time">2023/10/24</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/OBC SDWAN开放接口-20200420.pdf"
                        download="SDWAN开放接口-20200420.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">SDWAN开放接口.pdf</h4>
                        <p class="item-time">2021/4/23</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/SD-WAN全球技术与产业发展白皮书.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">全球技术与产业发展白皮书.pdf</h4>
                        <p class="item-time">2018/11/14</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/OBC SDK白皮书与集成-v0.3.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">SDK白皮书与集成.pdf</h4>
                        <p class="item-time">2018/11/14</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/D100-AWL5 设备上线操作指引(1)(1).pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">设备上线操作指引.pdf</h4>
                        <p class="item-time">2018/11/14</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/Oceanblue SD-WAN Solution Proposal.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">
                            Oceanblue SD-WAN Solution Proposal.pdf
                        </h4>
                        <p class="item-time">2023/9/11</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/Oceanblue Cloud SD-WAN Custom Development API Interface.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">
                            Oceanblue Cloud SD-WAN Custom Development API
                            Interface.pdf
                        </h4>
                        <p class="item-time">2023/9/11</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                    <a
                        target="_blank"
                        href="https://minio.oceanbluecloud.com/attachment/Oceanblue Cloud SD-WAN Restful-API Interface.pdf"
                        class="data-item reveal-bottom"
                    >
                        <h4 class="item-title">
                            Oceanblue Cloud SD-WAN Restful-API Interface.pdf
                        </h4>
                        <p class="item-time">2023/9/11</p>
                        <img
                            class="item-icon"
                            :src="require('@/assets/img_svg/download.svg')"
                            alt="svg"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import New from "@/components/New.vue";
import initAnimation from "../animation";
export default {
    data() {
        return {
            img: require("@/assets/images/sub_page_banner_9.jpg"),
            newImg: require("@/assets/images/news/new.png"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        SubHeader,
        New,
    },
};
</script>
<style scoped>
.box {
    width: 1200px;
    margin: auto;
}
.pages {
    width: 100px;
    height: 14px;
    margin: 85px auto 85px;
    display: flex;
    justify-content: space-between;
}
.pages-item {
    width: 29px;
    height: 14px;
    cursor: pointer;
}
.not {
    transform: rotate(180deg);
}
.data {
    background: #f2f2f2;
    overflow: hidden;
}
.data-cont {
    width: 1200px;
    margin: auto;
}
.data-title {
    font-size: 44px;
    color: #000000;
    font-weight: bold;
    margin-top: 100px;
    margin-bottom: 22px;
}
.data-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 117px;
}
.data-item {
    display: block;
    width: 590px;
    height: 120px;
    box-sizing: border-box;
    padding: 20px 30px;
    background-color: #fff;
    position: relative;
    cursor: pointer;
    margin-top: 20px;
}
.item-title {
    width: 70%;
    font-size: 18px;
    color: #333333;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: bold;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.item-time {
    font-size: 14px;
    color: #8d8d8d;
    letter-spacing: 0;
    line-height: 40px;
}
.item-icon {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 30px;
    top: 44px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/WhitePage/WhitePage.vue